import { Flex, Box, Text, Card, Theme, Button } from "@radix-ui/themes";
import React, { useState } from "react";

import { Input } from "@/components/ui/input";
import { Send } from "lucide-react";
import { OrganizationAnalysis } from "./blocks/organizationAnalysis";
import { TicketBrief } from "./blocks/ticketBrief";
import { Translation } from "./blocks/translation";
import { AssociatedJiraTickets } from "./blocks/associatedJiraTickets";
import { SuggestedReply } from "./blocks/suggestedReply";
import { SentimentCard } from "@/v2/features/copilot-blocks/sentiment-card";
import { SupportTicketSummary } from "@/v2/features/copilot-blocks/support-ticket-summary";
import { SupportTicketHistory } from "@/v2/features/copilot-blocks/support-ticket-history";
import { SuggestedScenarios } from "./blocks/support-scenarios-card";

export function Copilot({
  views,
  blocks,
}: {
  views: string[];
  blocks: { view: string; type: string; id: string }[];
}) {
  const [view, setViews] = useState("main");

  const relevantBlocks = blocks.filter((y) => y.view === view);

  return (
    <Theme
      className="qc-themes light"
      accentColor={"gray"}
      grayColor={"slate"}
      radius={"small"}
    >
      <Text size={"1"} className="text-gray-500">
        Preview of the agent's copilot
      </Text>
      <Box className="qc-Chat__Widget" mt={"1"}>
        <Card
          variant="classic"
          size={"5"}
          style={{
            padding: "0",
            display: "flex",
            flexDirection: "column",
            position: "relative",
            width: "500px",
            height: "80vh",
          }}
          className="qc-Chat__Widget__Card"
        >
          <Flex direction={"column"} gap={"4"} p={"4"} flexGrow={"1"}>
            {/* <Flex gap={"2"} width={"100%"} wrap={"wrap"}>
              {views.map((x) => {
                return (
                  <Button
                    key={x}
                    color={"gray"}
                    variant={"outline"}
                    radius={"large"}
                    size={"1"}
                    onClick={() => setViews(x)}
                  >
                    <StretchVertical className="w-4 h-4 " />
                    <Text size={"1"} className="capitalize">
                      {x} View
                    </Text>
                  </Button>
                );
              })}
            </Flex> */}
            {relevantBlocks.length == 0 && (
              <Flex justify={"center"} align={"center"} flexGrow={"1"}>
                <p>No Blocks, Ask your admin to add some blocks</p>
              </Flex>
            )}
            <Flex
              direction={"column"}
              gap={"2"}
              overflow={"auto"}
              flexGrow={"1"}
              height={"100px"}
            >
              {relevantBlocks.map((block) => {
                return (
                  <div key={block.id}>
                    {block.type === "userSentiment" && <SentimentCard />}
                    {block.type === "organizationAnlaysis" && (
                      <OrganizationAnalysis />
                    )}
                    {block.type === "ticketBrief" && <TicketBrief />}
                    {block.type === "ticketSummary" && (
                      <SupportTicketSummary
                        {...{
                          ticketId: "TKT-2024-001234",
                          summary:
                            "User experiencing login issues on mobile app after recent password reset. Unable to access account despite correct credentials. Issue appears to be related to session management on iOS devices. User has tried clearing cache and reinstalling app without success.",
                          userInfo: {
                            name: "Sarah Chen",
                            email: "sarah.chen@company.com",
                            location: "San Francisco, CA",
                            accountStatus: "VIP",
                            sentiment: "Frustrated",
                          },
                          timeline: {
                            opened: "2024-01-15 09:23 AM",
                            lastResponse: "2024-01-15 11:45 AM",
                            responseTime: "2h 22m",
                          },
                          artifacts: {
                            productVersion: "v2.4.1",
                            platform: "iOS 17.2",
                            attachments: 3,
                          },
                          rootCause:
                            "Known issue with OAuth token refresh on iOS after password reset",
                          recommendations: [
                            "Clear app keychain data",
                            "Send password reset link",
                            "Escalate to iOS dev team if issue persists",
                          ],
                        }}
                      />
                    )}
                    {block.type === "previousTicketResolution" && (
                      <SupportTicketHistory
                        customerName="Alex Thompson"
                        tickets={[
                          {
                            id: "1",
                            title: "Account Access Failure",
                            category: "Authentication",
                            description:
                              "User unable to log in after password reset, receiving 'invalid credentials' error despite correct password.",
                            resolution:
                              "Reset authentication tokens and cleared browser cache. Provided step-by-step login guide.",
                            status: "resolved",
                            sentiment: "positive",
                            closedDate: "2024-01-15",
                            daysAgo: 12,
                            agentName: "Sarah Chen",
                          },
                        ]}
                        totalTickets={8}
                      />
                    )}
                    {block.type === "suggestedScenarios" && (
                      <SuggestedScenarios />
                    )}
                    {block.type === "translation" && <Translation />}
                    {block.type === "associatedJiraTickets" && (
                      <AssociatedJiraTickets />
                    )}
                    {block.type === "suggestedReply" && <SuggestedReply />}
                  </div>
                );
              })}
            </Flex>
            {relevantBlocks.some((x) => x.type === "askAnything") && (
              <Flex className=" p-4 border-t border-gray-200 items-center gap-2">
                <Input className="w-full" placeholder="Ask anything..." />
                <Button
                  variant="ghost"
                  size="3"
                  className="h-12 w-12 p-0 rounded-full"
                >
                  <Send className="h-4 w-4" />
                </Button>
              </Flex>
            )}
          </Flex>
        </Card>
      </Box>
    </Theme>
  );
}
